// 下载设置弹窗容器：渲染筛选器/指标选择 UI，调用 useDownloadSettings 管理选中并回传确认结果
import React from 'react';
import { Modal, Button } from 'tea-component';
import { useIntl } from 'umi';
import { IDownloadSettingsModalProps } from './_type';
import { useDownloadSettings } from './hooks';
import FilterSelector from './components/FilterSelector';
import MetricSelector from './components/MetricSelector';
import './index.scss';
import classNames from 'classnames';

/**
 * 下载设置弹窗组件
 * 支持多选筛选器和指标
 */
const DownloadSettingsModal: React.FC<IDownloadSettingsModalProps> = (props) => {
  const {
    visible,
    onCancel,
    onConfirm,
    currentFilterVal,
    currentMetric,
    showFilters,
    showMetrics,
  } = props;

  const { formatMessage } = useIntl();

  const {
    selectedFilters,
    selectedMetrics,
    filterOptionsList,
    metricOptions,
    toggleMetric,
    toggleFilter,
  } = useDownloadSettings({
    visible,
    currentFilterVal,
    currentMetric,
    showFilters,
    showMetrics,
    effectiveSelected: props.effectiveSelected,
    allFilters: props.allFilters,
    getFilteredOptions: props.getFilteredOptions,
    filterMetricsByCascade: props.filterMetricsByCascade,
    getDimensionName: props.getDimensionName,
    metricsInfo: props.metricsInfo,
  });

  // 处理确认
  const handleConfirm = (): void => {
    onConfirm({
      filters: selectedFilters,
      metrics: selectedMetrics,
    });
  };

  // 处理取消
  const handleCancel = (): void => {
    onCancel();
  };

  return (
    <Modal
      visible={visible}
      onClose={handleCancel}
      className="dba-download-settings-modal"
      caption={formatMessage({ id: 'dba_download_settings' })}
      size="l"
    >
      <Modal.Body>
        <div className="dba-download-settings-content dba-scroll-bar">
          {/* 筛选器选择（与页面顺序保持一致：先维度后指标） */}
          {filterOptionsList?.map((filter) => (
            <FilterSelector
              key={filter?.data_key}
              filter={filter}
              selectedValues={selectedFilters[filter.data_key] || []}
              onToggle={(value) => toggleFilter(filter.data_key, value)}
            />
          ))}

          {/* 指标选择：即使只有一个也要显示（但不显示选择器，自动选中） */}
          {metricOptions?.length > 0 && (
            <MetricSelector
              className={classNames({
                // 优化：如果只有指标，则宽度调小
                'dba-download-settings-no-selector': !(filterOptionsList?.filter(item => item?.options?.length > 1)?.length > 0),
              })}
              options={metricOptions}
              selectedValues={selectedMetrics}
              onToggle={toggleMetric}
            />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={handleConfirm}>
          {formatMessage({ id: 'dba_confirm' })}
        </Button>
        <Button type="weak" onClick={handleCancel} style={{ marginLeft: 10 }}>
          {formatMessage({ id: 'dba_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DownloadSettingsModal;
